import React from 'react';
import { Outlet, useOutletContext, useParams } from 'react-router-dom';
import { User } from '../../../../../../models/interfaces/User.interface';
import { BusinessObject } from '../../../../../../models/interfaces/BusinessObject.interface';
import { ProductCategory } from '../../../../../../models/interfaces/ProductCategory.interface';
import businessObjectService from '../../../../../../services/business-object.service';

export default function CategoryDetailContextComponent() {
  const { user, businessObject } = useOutletContext<{ user: User; businessObject: BusinessObject }>();
  const { categoryId } = useParams();

  const [category, setCategory] = React.useState<ProductCategory>(null);

  React.useEffect(() => {
    const getCategory = async (userEmail: string, boId: number, categoryId: number) => {
      const data = await businessObjectService.getCategoryById(userEmail, boId, categoryId);
      setCategory(data);

      return data;
    };

    if (user?.email && businessObject?.id && categoryId) {
      getCategory(user?.email, businessObject?.id, Number(categoryId));
    }
  }, [user, businessObject, categoryId]);

  return <Outlet context={{ user, businessObject, category }} />;
}
